import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error',
  imports: [TranslateModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  private activatedRoute = inject(ActivatedRoute);

  get errorCode(): string {
    return this.activatedRoute.snapshot.queryParams['code'];
  }
}
